// extracted by mini-css-extract-plugin
export default {"content":"e58OX6LqZgEg9DqQxLA1"};